import { Transform } from 'class-transformer';

export function TransformBigInt() {
  return Transform(val => {
    if (typeof val.value === 'bigint') {
      return val.value.toString();
    }

    return val.value ? BigInt(val.value) : undefined;
  });
}
